import React from 'react';

// Components
import LoginForm from '../components/Form/LoginForm';

const Login = () => {
	return (
		<section className="login">
			<LoginForm />
		</section>
	);
};

export default Login;
